module.exports = __webpack_public_path__ + "static/media/origPortBG.90c12c48.png";